import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const generateCopSchedules = api(async function generateCopSchedules({ codeOfPracticeId }) {
    return mutate(
        gql`
            mutation GenerateCopSchedules($codeOfPracticeId: ID!) {
                generateCopSchedules(codeOfPracticeId: $codeOfPracticeId)
            }
        `,
        { codeOfPracticeId },
        { returns: "generateCopSchedules" }
    )
})
